/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createProduct = /* GraphQL */ `
  mutation CreateProduct(
    $input: CreateProductInput!
    $condition: ModelProductConditionInput
  ) {
    createProduct(input: $input, condition: $condition) {
      id
      name
      description
      price
      cost
      sku
      image
      details {
        items {
          id
          productID
          name
          content
          createdAt
          updatedAt
        }
        nextToken
      }
      reviews {
        items {
          id
          productID
          title
          content
          stars
          createdAt
          updatedAt
        }
        nextToken
      }
      transactions {
        items {
          id
          productID
          transactionID
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateProduct = /* GraphQL */ `
  mutation UpdateProduct(
    $input: UpdateProductInput!
    $condition: ModelProductConditionInput
  ) {
    updateProduct(input: $input, condition: $condition) {
      id
      name
      description
      price
      cost
      sku
      image
      details {
        items {
          id
          productID
          name
          content
          createdAt
          updatedAt
        }
        nextToken
      }
      reviews {
        items {
          id
          productID
          title
          content
          stars
          createdAt
          updatedAt
        }
        nextToken
      }
      transactions {
        items {
          id
          productID
          transactionID
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteProduct = /* GraphQL */ `
  mutation DeleteProduct(
    $input: DeleteProductInput!
    $condition: ModelProductConditionInput
  ) {
    deleteProduct(input: $input, condition: $condition) {
      id
      name
      description
      price
      cost
      sku
      image
      details {
        items {
          id
          productID
          name
          content
          createdAt
          updatedAt
        }
        nextToken
      }
      reviews {
        items {
          id
          productID
          title
          content
          stars
          createdAt
          updatedAt
        }
        nextToken
      }
      transactions {
        items {
          id
          productID
          transactionID
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createTransactionProducts = /* GraphQL */ `
  mutation CreateTransactionProducts(
    $input: CreateTransactionProductsInput!
    $condition: ModelTransactionProductsConditionInput
  ) {
    createTransactionProducts(input: $input, condition: $condition) {
      id
      productID
      transactionID
      product {
        id
        name
        description
        price
        cost
        sku
        image
        details {
          nextToken
        }
        reviews {
          nextToken
        }
        transactions {
          nextToken
        }
        createdAt
        updatedAt
      }
      transaction {
        id
        createdAt
        customerID
        customer {
          id
          userID
          username
          firstname
          middlename
          lastname
          phone
          number
          createdAt
          updatedAt
        }
        total
        subtotal
        shipping
        tax
        products {
          nextToken
        }
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateTransactionProducts = /* GraphQL */ `
  mutation UpdateTransactionProducts(
    $input: UpdateTransactionProductsInput!
    $condition: ModelTransactionProductsConditionInput
  ) {
    updateTransactionProducts(input: $input, condition: $condition) {
      id
      productID
      transactionID
      product {
        id
        name
        description
        price
        cost
        sku
        image
        details {
          nextToken
        }
        reviews {
          nextToken
        }
        transactions {
          nextToken
        }
        createdAt
        updatedAt
      }
      transaction {
        id
        createdAt
        customerID
        customer {
          id
          userID
          username
          firstname
          middlename
          lastname
          phone
          number
          createdAt
          updatedAt
        }
        total
        subtotal
        shipping
        tax
        products {
          nextToken
        }
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteTransactionProducts = /* GraphQL */ `
  mutation DeleteTransactionProducts(
    $input: DeleteTransactionProductsInput!
    $condition: ModelTransactionProductsConditionInput
  ) {
    deleteTransactionProducts(input: $input, condition: $condition) {
      id
      productID
      transactionID
      product {
        id
        name
        description
        price
        cost
        sku
        image
        details {
          nextToken
        }
        reviews {
          nextToken
        }
        transactions {
          nextToken
        }
        createdAt
        updatedAt
      }
      transaction {
        id
        createdAt
        customerID
        customer {
          id
          userID
          username
          firstname
          middlename
          lastname
          phone
          number
          createdAt
          updatedAt
        }
        total
        subtotal
        shipping
        tax
        products {
          nextToken
        }
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createTransaction = /* GraphQL */ `
  mutation CreateTransaction(
    $input: CreateTransactionInput!
    $condition: ModelTransactionConditionInput
  ) {
    createTransaction(input: $input, condition: $condition) {
      id
      createdAt
      customerID
      customer {
        id
        userID
        username
        firstname
        middlename
        lastname
        phone
        number
        transactions {
          nextToken
        }
        createdAt
        updatedAt
      }
      total
      subtotal
      shipping
      tax
      products {
        items {
          id
          productID
          transactionID
          createdAt
          updatedAt
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const updateTransaction = /* GraphQL */ `
  mutation UpdateTransaction(
    $input: UpdateTransactionInput!
    $condition: ModelTransactionConditionInput
  ) {
    updateTransaction(input: $input, condition: $condition) {
      id
      createdAt
      customerID
      customer {
        id
        userID
        username
        firstname
        middlename
        lastname
        phone
        number
        transactions {
          nextToken
        }
        createdAt
        updatedAt
      }
      total
      subtotal
      shipping
      tax
      products {
        items {
          id
          productID
          transactionID
          createdAt
          updatedAt
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const deleteTransaction = /* GraphQL */ `
  mutation DeleteTransaction(
    $input: DeleteTransactionInput!
    $condition: ModelTransactionConditionInput
  ) {
    deleteTransaction(input: $input, condition: $condition) {
      id
      createdAt
      customerID
      customer {
        id
        userID
        username
        firstname
        middlename
        lastname
        phone
        number
        transactions {
          nextToken
        }
        createdAt
        updatedAt
      }
      total
      subtotal
      shipping
      tax
      products {
        items {
          id
          productID
          transactionID
          createdAt
          updatedAt
        }
        nextToken
      }
      updatedAt
    }
  }
`;
export const createCustomer = /* GraphQL */ `
  mutation CreateCustomer(
    $input: CreateCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    createCustomer(input: $input, condition: $condition) {
      id
      userID
      username
      firstname
      middlename
      lastname
      phone
      number
      transactions {
        items {
          id
          createdAt
          customerID
          total
          subtotal
          shipping
          tax
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateCustomer = /* GraphQL */ `
  mutation UpdateCustomer(
    $input: UpdateCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    updateCustomer(input: $input, condition: $condition) {
      id
      userID
      username
      firstname
      middlename
      lastname
      phone
      number
      transactions {
        items {
          id
          createdAt
          customerID
          total
          subtotal
          shipping
          tax
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteCustomer = /* GraphQL */ `
  mutation DeleteCustomer(
    $input: DeleteCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    deleteCustomer(input: $input, condition: $condition) {
      id
      userID
      username
      firstname
      middlename
      lastname
      phone
      number
      transactions {
        items {
          id
          createdAt
          customerID
          total
          subtotal
          shipping
          tax
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createInventory = /* GraphQL */ `
  mutation CreateInventory(
    $input: CreateInventoryInput!
    $condition: ModelInventoryConditionInput
  ) {
    createInventory(input: $input, condition: $condition) {
      id
      productID
      count
      createdAt
      updatedAt
    }
  }
`;
export const updateInventory = /* GraphQL */ `
  mutation UpdateInventory(
    $input: UpdateInventoryInput!
    $condition: ModelInventoryConditionInput
  ) {
    updateInventory(input: $input, condition: $condition) {
      id
      productID
      count
      createdAt
      updatedAt
    }
  }
`;
export const deleteInventory = /* GraphQL */ `
  mutation DeleteInventory(
    $input: DeleteInventoryInput!
    $condition: ModelInventoryConditionInput
  ) {
    deleteInventory(input: $input, condition: $condition) {
      id
      productID
      count
      createdAt
      updatedAt
    }
  }
`;
export const createProductReview = /* GraphQL */ `
  mutation CreateProductReview(
    $input: CreateProductReviewInput!
    $condition: ModelProductReviewConditionInput
  ) {
    createProductReview(input: $input, condition: $condition) {
      id
      productID
      title
      content
      stars
      product {
        id
        name
        description
        price
        cost
        sku
        image
        details {
          nextToken
        }
        reviews {
          nextToken
        }
        transactions {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateProductReview = /* GraphQL */ `
  mutation UpdateProductReview(
    $input: UpdateProductReviewInput!
    $condition: ModelProductReviewConditionInput
  ) {
    updateProductReview(input: $input, condition: $condition) {
      id
      productID
      title
      content
      stars
      product {
        id
        name
        description
        price
        cost
        sku
        image
        details {
          nextToken
        }
        reviews {
          nextToken
        }
        transactions {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteProductReview = /* GraphQL */ `
  mutation DeleteProductReview(
    $input: DeleteProductReviewInput!
    $condition: ModelProductReviewConditionInput
  ) {
    deleteProductReview(input: $input, condition: $condition) {
      id
      productID
      title
      content
      stars
      product {
        id
        name
        description
        price
        cost
        sku
        image
        details {
          nextToken
        }
        reviews {
          nextToken
        }
        transactions {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createProductDetail = /* GraphQL */ `
  mutation CreateProductDetail(
    $input: CreateProductDetailInput!
    $condition: ModelProductDetailConditionInput
  ) {
    createProductDetail(input: $input, condition: $condition) {
      id
      productID
      name
      content
      createdAt
      updatedAt
    }
  }
`;
export const updateProductDetail = /* GraphQL */ `
  mutation UpdateProductDetail(
    $input: UpdateProductDetailInput!
    $condition: ModelProductDetailConditionInput
  ) {
    updateProductDetail(input: $input, condition: $condition) {
      id
      productID
      name
      content
      createdAt
      updatedAt
    }
  }
`;
export const deleteProductDetail = /* GraphQL */ `
  mutation DeleteProductDetail(
    $input: DeleteProductDetailInput!
    $condition: ModelProductDetailConditionInput
  ) {
    deleteProductDetail(input: $input, condition: $condition) {
      id
      productID
      name
      content
      createdAt
      updatedAt
    }
  }
`;
export const createEmployee = /* GraphQL */ `
  mutation CreateEmployee(
    $input: CreateEmployeeInput!
    $condition: ModelEmployeeConditionInput
  ) {
    createEmployee(input: $input, condition: $condition) {
      id
      firstName
      lastName
      createdAt
      updatedAt
    }
  }
`;
export const updateEmployee = /* GraphQL */ `
  mutation UpdateEmployee(
    $input: UpdateEmployeeInput!
    $condition: ModelEmployeeConditionInput
  ) {
    updateEmployee(input: $input, condition: $condition) {
      id
      firstName
      lastName
      createdAt
      updatedAt
    }
  }
`;
export const deleteEmployee = /* GraphQL */ `
  mutation DeleteEmployee(
    $input: DeleteEmployeeInput!
    $condition: ModelEmployeeConditionInput
  ) {
    deleteEmployee(input: $input, condition: $condition) {
      id
      firstName
      lastName
      createdAt
      updatedAt
    }
  }
`;
